import Qty from 'js-quantities'

export function convertUnit(number: number, fromUnit?: string, toUnit?: string) {
  if (!Number.isFinite(number)) {
    number = 0
  }

  let converted: Qty
  try {
    converted = fromUnit ? Qty(number, fromUnit) : Qty(number)
  } catch (err) {
    return { value: number, unit: fromUnit }
  }

  if (toUnit) {
    if (!converted.isCompatible(toUnit)) {
      console.warn(`Unit ${fromUnit} is not compatible with ${toUnit}`)
    } else {
      converted = converted.to(toUnit)
    }
  }

  let formattedUnit = converted.units()

  return { value: converted.scalar, unit: formattedUnit }
}
